/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/react-in-jsx-scope */
import { Alert, Box, Grid } from "@mui/material";
import { Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../../components/common/new/InputField/InputField";
import Button from "../../../../components/common/Button";
import Toast from "../../../../components/common/Toast";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { MEMBER_PROFILE_CREATE } from "../../../../contants/formFields";
import { selectMemberProfile } from "../../../../redux/selectors/member";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import Member from "../../../../services/api/member";
import { getOptions } from "../../../../utils";
import { debounce } from "../../../../utils/helper";
import Styles from "./MemberProfileForm.styles";
import { AlertStatus, PERMISSIONS } from "../../../../contants";
import useUserConfig from "../../../../hooks/useUserConfig";
import ProfilePictureModal from "../../../../components/common/new/ProfilePictureModal/ProfilePictureModal";
import { getInitials } from "../../memberDetails/utlis";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import Typography from "../../../../components/common/new/Typography/Typography";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
// import OrganizationStructure from "../../../../components/common/OrganizationStructure/OrganizationStructure";

function ProfileForm({
  values,
  handleChange,
  errors,
  setFieldValue,
  setCities,
  states,
  cities,
  countries,
  university,
  profession,
  // memberProfile,
  block,
  hasPermission,
  isLoading,
  isDistrictSi,
  isChapterSi,
  isHelpDesk,
  isHelpDeskAdmin,
  divisions,
  subDivisions,
  setSubDivisions,
}) {
  const navigate = useNavigate();
  // const [phoneNumber, setPhoneNumber] = useState("");
  // const [address, setAddress] = useState("");

  const onCancel = () => {
    navigate(-1);
  };

  // const isStudent =
  //   memberProfile.divisionId === 3 || memberProfile.divisionId === 37;

  return (
    <Box>
      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={5.5}>
          {/* <InputField
            label="Full Name"
            placeholder="Full Name.."
            name={MEMBER_PROFILE_CREATE.NAME}
            value={values[MEMBER_PROFILE_CREATE.NAME]}
            onChange={handleChange}
            disabled={!hasPermission(PERMISSIONS.UPDATE_MEMBER_NAME)}
          /> */}
          <InputField
            label="Full Name"
            placeholder="Full Name.."
            name={MEMBER_PROFILE_CREATE.NAME}
            value={values[MEMBER_PROFILE_CREATE.NAME]}
            onChange={(e) => {
              const { value } = e.target;

              // Allowed: Letters, space, dot, hyphen
              const regex = /^[A-Za-z ]*$/;

              if (regex.test(value)) {
                // Block leading space
                if (value.startsWith(" ")) return;

                // Block only spaces
                if (value.trim().length === 0 && value.length > 0) return;
                handleChange(e);
              }
            }}
            disabled={!hasPermission(PERMISSIONS.UPDATE_MEMBER_NAME)}
          />
        </Grid>
        <Grid item xs={5.5} />
        <Grid item xs={5.5} mr="16px">
          <InputField
            // required
            placeholder="Email"
            label="Email"
            type="email"
            name={MEMBER_PROFILE_CREATE.EMAIL_ADDRESS}
            value={values[MEMBER_PROFILE_CREATE.EMAIL_ADDRESS]}
            onChange={handleChange}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
        <Grid item xs={5.5}>
          {/* <InputField
            required
            placeholder="Phone Number"
            label="Phone No."
            type="text"
            name={MEMBER_PROFILE_CREATE.CONTACT_NUMBER}
            value={values[MEMBER_PROFILE_CREATE.CONTACT_NUMBER]}
            onChange={handleChange}
            inputProps={{
              maxLength: 10,
            }}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          /> */}
          <InputField
            required
            placeholder="Phone Number"
            label="Phone No."
            type="text"
            name={MEMBER_PROFILE_CREATE.CONTACT_NUMBER}
            value={values[MEMBER_PROFILE_CREATE.CONTACT_NUMBER]}
            onChange={(e) => {
              const { value } = e.target;
              // Only digits allowed (0–9)
              const regex = /^[0-9]*$/;
              if (regex.test(value)) {
                // setPhoneNumber(value);
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 10,
            }}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            placeholder="Date of Birth"
            label="Date of Birth"
            type="date"
            name={MEMBER_PROFILE_CREATE.DATE_OF_BIRTH}
            value={values[MEMBER_PROFILE_CREATE.DATE_OF_BIRTH]}
            onChange={handleChange}
            InputProps={{
              startAdornment: <></>,
            }}
            disabled={
              !hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB) && !isHelpDesk
            }
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.countryName}
            name={MEMBER_PROFILE_CREATE.NATIONALITY_ID}
            options={getOptions(countries, "countryId")}
            inputProps={{ required: true }}
            error={errors[MEMBER_PROFILE_CREATE.NATIONALITY_ID]}
            value={Number(values[MEMBER_PROFILE_CREATE.NATIONALITY_ID])}
            label="Nationality/Country"
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.NATIONALITY_ID,
                selectedValue?.value ?? ""
              );
            }}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
      </Grid>
      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={5.5} mr="16px">
          {/* <InputField
            required
            placeholder="Address"
            label="Address"
            type="text"
            name={MEMBER_PROFILE_CREATE.ADDRESS_LINE_1}
            value={values[MEMBER_PROFILE_CREATE.ADDRESS_LINE_1]}
            onChange={handleChange}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          /> */}
          <InputField
            required
            placeholder="Address"
            label="Address"
            type="text"
            name={MEMBER_PROFILE_CREATE.ADDRESS_LINE_1}
            value={values[MEMBER_PROFILE_CREATE.ADDRESS_LINE_1]}
            onChange={(e) => {
              const { value } = e.target;
              // alphabets, digits, space, comma, hyphen, dot, slash allowed
              const regex = /^[A-Za-z0-9 ,.\-/]*$/;
              if (regex.test(value)) {
                // setAddress(value);
                // Block leading space
                if (value.startsWith(" ")) return;

                // Block only spaces
                if (value.trim().length === 0 && value.length > 0) return;
                handleChange(e);
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          {/* <InputField
            placeholder="Pincode"
            label="Pincode"
            type="text"
            name={MEMBER_PROFILE_CREATE.PINCODE}
            value={values[MEMBER_PROFILE_CREATE.PINCODE]}
            onChange={handleChange}
            inputProps={{
              maxLength: 6,
            }}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          /> */}
          <InputField
            placeholder="Pincode"
            label="Pincode"
            type="text"
            name={MEMBER_PROFILE_CREATE.PINCODE}
            value={values[MEMBER_PROFILE_CREATE.PINCODE] || ""}
            onChange={(e) => {
              const { value } = e.target;
              const regex = /^[0-9]*$/; // only digits allowed

              if (regex.test(value)) {
                setFieldValue(MEMBER_PROFILE_CREATE.PINCODE, value);
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 6,
            }}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.stateName}
            label="State"
            name={MEMBER_PROFILE_CREATE.STATE}
            options={getOptions(states, "stateId")}
            error={errors[MEMBER_PROFILE_CREATE.STATE]}
            value={values[MEMBER_PROFILE_CREATE.STATE]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.STATE, "");
                setCities([]);
              } else {
                setFieldValue(MEMBER_PROFILE_CREATE.STATE, selectedValue.value);
                setCities(selectedValue.cities);
              }
              setFieldValue(MEMBER_PROFILE_CREATE.CITY, "");
            }}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.cityName}
            label="City"
            name={MEMBER_PROFILE_CREATE.CITY}
            options={getOptions(cities, "cityId")}
            error={errors[MEMBER_PROFILE_CREATE.CITY]}
            value={values[MEMBER_PROFILE_CREATE.CITY]}
            disabled={
              !values[MEMBER_PROFILE_CREATE.STATE]
              // ||
              // (!isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin)
            }
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.CITY, "");
              } else {
                setFieldValue(MEMBER_PROFILE_CREATE.CITY, selectedValue.value);
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            label="Profession"
            variant="standard"
            value={values[MEMBER_PROFILE_CREATE.PROFESSION]}
            name={MEMBER_PROFILE_CREATE.PROFESSION}
            error={errors[MEMBER_PROFILE_CREATE.PROFESSION]}
            getOptionLabel={(option) => option.profession}
            options={getOptions(profession, "professionsId")}
            // inputProps={{ required: true }}
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.PROFESSION,
                selectedValue?.value ?? ""
              );
            }}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
        <Grid item xs={5.5} />
        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Division"
            name={MEMBER_PROFILE_CREATE.DIVISION}
            options={getOptions(divisions, "divisionId")}
            error={errors[MEMBER_PROFILE_CREATE.DIVISION]}
            value={values[MEMBER_PROFILE_CREATE.DIVISION]}
            disabled={
              // values[MEMBER_PROFILE_CREATE.DIVISION] ||
              !isHelpDesk && !isHelpDeskAdmin
            }
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.DIVISION, "");
                setSubDivisions([]);
              } else {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.DIVISION,
                  selectedValue.value
                );
                setSubDivisions(selectedValue.subDivisions);
              }
              setFieldValue(MEMBER_PROFILE_CREATE.SUB_DIVISION, "");
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Sub Division"
            name={MEMBER_PROFILE_CREATE.SUB_DIVISION}
            options={getOptions(subDivisions, "divisionId")}
            error={errors[MEMBER_PROFILE_CREATE.SUB_DIVISION]}
            value={values[MEMBER_PROFILE_CREATE.SUB_DIVISION]}
            disabled={
              // !values[MEMBER_PROFILE_CREATE.DIVISION] ||
              !isHelpDesk && !isHelpDeskAdmin
            }
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.SUB_DIVISION, "");
              } else {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.SUB_DIVISION,
                  selectedValue.value
                );
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            name={MEMBER_PROFILE_CREATE.UNIVERSITY_ID}
            options={getOptions(university, "id")}
            error={errors[MEMBER_PROFILE_CREATE.UNIVERSITY_ID]}
            value={Number(values[MEMBER_PROFILE_CREATE.UNIVERSITY_ID])}
            label="University"
            // inputProps={{
            //   required: !!isStudent,
            // }}
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.UNIVERSITY_ID,
                selectedValue?.value ?? ""
              );
            }}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            placeholder="College"
            label="College"
            type="text"
            name={MEMBER_PROFILE_CREATE.COLLEGE}
            value={values[MEMBER_PROFILE_CREATE.COLLEGE]}
            onChange={handleChange}
            // disabled
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            placeholder="Education Qualification"
            label="Education Qualification"
            type="text"
            name={MEMBER_PROFILE_CREATE.EDUCATIONQUALIFICATION}
            value={values[MEMBER_PROFILE_CREATE.EDUCATIONQUALIFICATION]}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            placeholder="Company Name"
            label="Company Name"
            type="text"
            name={MEMBER_PROFILE_CREATE.COMPANYNAME}
            value={values[MEMBER_PROFILE_CREATE.COMPANYNAME]}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            placeholder="Occupation"
            label="Occupation"
            type="text"
            name={MEMBER_PROFILE_CREATE.OCCUPATION}
            value={values[MEMBER_PROFILE_CREATE.OCCUPATION]}
            onChange={handleChange}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            placeholder="Designation"
            label="Designation"
            type="text"
            name={MEMBER_PROFILE_CREATE.DESIGNATION}
            value={values[MEMBER_PROFILE_CREATE.DESIGNATION]}
            onChange={handleChange}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
      </Grid>
      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={5.5} mr="16px">
          {/* <InputField
            required
            placeholder="Introducer's Name"
            label="Introducer's Name"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME]}
            onChange={handleChange}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          /> */}
          <InputField
            required
            placeholder="Introducer's Name"
            label="Introducer's Name"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME] || ""}
            onChange={(e) => {
              const { value } = e.target;
              // Allowed: letters, spaces, hyphen
              const regex = /^[A-Za-z ]*$/;

              if (regex.test(value)) {
                // Block leading space
                if (value.startsWith(" ")) return;

                // Block only spaces
                if (value.trim().length === 0 && value.length > 0) return;
                setFieldValue(MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME, value);
                handleChange(e);
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          {/* <InputField
            required
            placeholder="Introducer's Contact Number"
            label="Introducer's Contact Number"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER]}
            onChange={handleChange}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          /> */}
          <InputField
            required
            placeholder="Introducer's Contact Number"
            label="Introducer's Contact Number"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER}
            value={
              values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER] || ""
            }
            onChange={(e) => {
              const { value } = e.target;
              const regex = /^[0-9]*$/; // Only digits allowed

              if (regex.test(value)) {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER,
                  value
                );
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 10, // Indian mobile number length
            }}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            // required
            placeholder="Introducer's Email"
            label="Introducer's Email"
            type="email"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL]}
            onChange={handleChange}
            // disabled={
            //   !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            // }
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            placeholder="Remark"
            label="Remark"
            type="text"
            name={MEMBER_PROFILE_CREATE.REMARK}
            value={values[MEMBER_PROFILE_CREATE.REMARK]}
            onChange={handleChange}
            // disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
      </Grid>
      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={5.5}>
              <Typography variant="title2">Organization Structure</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            label="Area"
            placeholder="Area"
            name={MEMBER_PROFILE_CREATE.AREA_NAME}
            value={values[MEMBER_PROFILE_CREATE.AREA_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            label="Zone"
            placeholder="Zone"
            name={MEMBER_PROFILE_CREATE.ZONE_NAME}
            value={values[MEMBER_PROFILE_CREATE.ZONE_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            label="Region"
            placeholder="Region"
            name={MEMBER_PROFILE_CREATE.REGION_NAME}
            value={values[MEMBER_PROFILE_CREATE.REGION_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            label="Chapter"
            placeholder="Chapter"
            name={MEMBER_PROFILE_CREATE.CHAPTER_NAME}
            value={values[MEMBER_PROFILE_CREATE.CHAPTER_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            label="District"
            placeholder="District"
            name={MEMBER_PROFILE_CREATE.DISTRICT_NAME}
            value={values[MEMBER_PROFILE_CREATE.DISTRICT_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            name={MEMBER_PROFILE_CREATE.BLOCK}
            options={getOptions(block, "structureId")}
            inputProps={{ required: true }}
            error={errors[MEMBER_PROFILE_CREATE.BLOCK]}
            value={Number(values[MEMBER_PROFILE_CREATE.BLOCK])}
            label="Block"
            disabled={
              !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            }
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.BLOCK,
                selectedValue?.value ?? ""
              );
            }}
          />
        </Grid>
      </Grid>
      <Box p="16px">
        <Button
          isLoading={isLoading}
          type="submit"
          label="Save Changes"
          style={{
            minWidth: "145px",
            marginRight: "20px",
          }}
        />
        <Button
          label="Cancel"
          variant="outlined"
          style={{
            minWidth: "145px",
          }}
          onClick={onCancel}
        />
      </Box>
    </Box>
  );
}

function MemberProfileForm({ isEdit = false }) {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [showToast, setShowToast] = useState(null);
  const { id } = useParams();
  const memberProfile = useSelector(selectMemberProfile);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const toast = useContext(ToastAlertContext);
  const [memberInfo, setMemberInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [university, setUniversity] = useState([]);
  const [profession, setProfession] = useState([]);
  const [block, setBlock] = useState([]);
  const { isDistrictSi, isChapterSi, isRegionSi, isHelpDesk, isHelpDeskAdmin } =
    useSelector(selectAllSIUsers);
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);

  const hasPermission = useUserConfig();

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);

    if (memberProfile.state) {
      const selectedState = response?.data?.find(
        (state) => Number(memberProfile?.state) === state.stateId
      );
      setCities(selectedState.cities);
    }
  };

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
    if (memberProfile.state) {
      const selectedValue = response?.data?.find(
        (division) => Number(memberProfile?.divisionId) === division.divisionId
      );
      setSubDivisions(selectedValue?.subDivisions);
    }
  };

  const getCountries = async () => {
    const response = await IntroductionFormApi.getCountries();
    setCountries(response.data);
  };

  const getUniversity = async () => {
    const response = await IntroductionFormApi.getUniversity();
    setUniversity(response.data);
  };

  const getProfessions = async () => {
    const response = await IntroductionFormApi.getProfessions();
    setProfession(response.data);
  };

  const getAllBlocks = async () => {
    if (memberProfile.districtId) {
      const response = await IntroductionFormApi.getBlocks({
        districtId: memberProfile.districtId,
      });
      setBlock(response.data);
    }
  };

  const getMemberDetails = async () => {
    try {
      const response = await Member.getMemberDetailsById(Number(id));
      setMemberInfo(response.data);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // const handleModalOpen = () => {
  //   setModalOpen(true);
  // };

  const handleModalClose = () => {
    setModalOpen((prev) => !prev);
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleImageUpload = async () => {
    try {
      if (selectedImage) {
        const file = new File([selectedImage], "image.jpg", {
          type: "image/jpeg",
        });

        const formData = new FormData();

        formData.append("file", file);

        setIsLoading(true);
        await Member.uploadProfilePhoto({
          memberId: Number(id),
          data: formData,
        });

        setMemberInfo((prevMemberInfo) => ({
          ...prevMemberInfo,
          profilePhotoUrl: URL.createObjectURL(selectedImage),
        }));

        toast.show("Image Uploaded Successfully", AlertStatus.SUCCESS);
        setTimeout(() => {
          setModalOpen(false);
        }, 2000);
      }
      setIsLoading(false);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getStates();
    getCountries();
    getUniversity();
    getProfessions();
    getAllBlocks();
    getMemberDetails();
    getDivisions();
  }, []);

  const onFormSubmit = async (values) => {
    try {
      setIsLoading(true);

      await Member.memberUpdate({ memberId: Number(id), ...values });
      setTimeout(() => {
        navigate(-2);
      }, 2000);

      setShowToast({
        message: isEdit
          ? "Member Updated Successfully"
          : "Member Created Successfully",
        severity: "success",
      });
      setIsLoading(false);
    } catch (error) {
      setShowToast({
        message: error.message ?? "something went wrong, try again",
        severity: "error",
      });
      setIsLoading(false);
      Sentry.captureException(error);
    }
  };

  return (
    <div>
      <Box style={Styles.headerContainer}>
        <Box
          style={{
            ...Styles.headerHeading,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {isEdit ? "Edit Profile" : "Add a Profile"}
          <Alert severity="error" style={{ maxWidth: "600px" }}>
            <Box>
              Name can&rsquo;t be changed if contribution has been made in the
              current financial year.
            </Box>
            <Box>Contact Region Stats to update member name</Box>
          </Alert>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box style={Styles.imageView}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              {memberInfo.profilePhotoUrl ? (
                <img
                  src={memberInfo.profilePhotoUrl}
                  alt="Profile"
                  style={Styles.profileImage}
                  width="100"
                  height="100"
                />
              ) : (
                <div>{getInitials(memberInfo.fullName)}</div>
              )}
            </div>
          </Box>
          {/* {hasPermission(PERMISSIONS.UPDATE_MEMBER_PROFILE_PHOTO) && (
            <Box style={Styles.uploadstyles}>
              <Box>
                <Button
                  label="UPLOAD NEW PHOTO"
                  style={{
                    width: "195px",
                  }}
                  onClick={handleModalOpen}
                />
              </Box>
              <Box style={Styles.uploadSubtitle}>
                Allowed PNG or JPEG. Max size of 800KB.
              </Box>
            </Box>
          )} */}
        </Box>
      </Box>
      <Box
        style={{
          width: "95%",
          margin: "auto",
        }}
      >
        <div style={Styles.card}>
          <Formik
            initialValues={{
              [MEMBER_PROFILE_CREATE.NAME]: memberProfile.fullName,
              [MEMBER_PROFILE_CREATE.EMAIL_ADDRESS]: memberProfile.emailId,
              [MEMBER_PROFILE_CREATE.CONTACT_NUMBER]:
                memberProfile.mobileNumber,
              [MEMBER_PROFILE_CREATE.DATE_OF_BIRTH]: memberProfile.dateOfBirth,
              [MEMBER_PROFILE_CREATE.NATIONALITY_ID]: Number(
                memberProfile.nationalityId
              ),
              [MEMBER_PROFILE_CREATE.ADDRESS_LINE_1]:
                memberProfile.addressLine1,
              [MEMBER_PROFILE_CREATE.STATE]: Number(memberProfile.state),
              [MEMBER_PROFILE_CREATE.CITY]: Number(memberProfile.city),
              [MEMBER_PROFILE_CREATE.PINCODE]: memberProfile.pincode,
              [MEMBER_PROFILE_CREATE.PROFESSION]: memberProfile.profession,
              [MEMBER_PROFILE_CREATE.PROFESSIONAL_SERVICE]:
                memberProfile.professionalServiceGroup,
              [MEMBER_PROFILE_CREATE.UNIVERSITY_ID]: memberProfile.universityId,
              [MEMBER_PROFILE_CREATE.COLLEGE]: memberProfile.collegeName,
              [MEMBER_PROFILE_CREATE.EDUCATIONQUALIFICATION]:
                memberProfile.educationalQualification,
              [MEMBER_PROFILE_CREATE.COMPANYNAME]: memberProfile.companyName,
              [MEMBER_PROFILE_CREATE.OCCUPATION]: memberProfile.occupation,
              [MEMBER_PROFILE_CREATE.DESIGNATION]: memberProfile.designation,
              [MEMBER_PROFILE_CREATE.DIVISION]: memberProfile.divisionId,
              [MEMBER_PROFILE_CREATE.SUB_DIVISION]: memberProfile.subdivisionId,
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME]:
                memberProfile.introducerName,
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER]:
                memberProfile.introducerMobileNumber,
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL]:
                memberProfile.introducerEmail,
              [MEMBER_PROFILE_CREATE.AREA_NAME]: memberProfile.areaName,
              [MEMBER_PROFILE_CREATE.ZONE_NAME]: memberProfile.zoneName,
              [MEMBER_PROFILE_CREATE.REGION_NAME]: memberProfile.regionName,
              [MEMBER_PROFILE_CREATE.CHAPTER_NAME]: memberProfile.chapterName,
              [MEMBER_PROFILE_CREATE.DISTRICT_NAME]: memberProfile.districtName,
              [MEMBER_PROFILE_CREATE.BLOCK]: memberProfile.blockId,
              // [MEMBER_PROFILE_CREATE.GOHONZON]: getGohonzonType(
              //   memberProfile?.gohonzonMemberships[0]?.type || ""
              // ),
            }}
            onSubmit={debounce(onFormSubmit)}
          >
            {({
              values,
              handleChange,
              errors,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <ProfileForm
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  handleSubmit={handleSubmit}
                  setFieldValue={setFieldValue}
                  setCities={setCities}
                  states={states}
                  cities={cities}
                  countries={countries}
                  university={university}
                  profession={profession}
                  memberProfile={memberProfile}
                  block={block}
                  hasPermission={hasPermission}
                  isLoading={isLoading}
                  isDistrictSi={isDistrictSi}
                  isChapterSi={isChapterSi}
                  isRegionSi={isRegionSi}
                  isHelpDesk={isHelpDesk}
                  isHelpDeskAdmin={isHelpDeskAdmin}
                  divisions={divisions}
                  subDivisions={subDivisions}
                  setSubDivisions={setSubDivisions}
                />
              </form>
            )}
          </Formik>
        </div>
        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => {
            setShowToast(null);
          }}
        />
        <ProfilePictureModal
          open={modalOpen}
          onClose={handleModalClose}
          handleImageChange={handleImageChange}
          handleImageUpload={handleImageUpload}
          memberProfile={memberProfile}
          isLoading={isLoading}
          toast={toast}
        />
      </Box>
    </div>
  );
}

export default MemberProfileForm;
